import React from "react";
import styles from "./OrderReview.module.css";
import CartList from "./CartList/CartList";
import OrderSummary from "./OrderSummary/OrderSummary";
import { allProducts } from '../../API/ProductsAPI';
import { NavLink } from "react-router-dom";

const OrderReview = (props) => {
  const isMobile = (window.innerWidth <= 768) ? true : false;
  let total = props.cart.reduce((total, product) => total + product.quantity * allProducts[product.id].prices[product.priceIndex].price, 0);

  return (
    <div>
      {
        (props.cart.length === 0)
          ? (props.currentStep)
            ? <h1>Comanda a fost inregistrata cu success</h1>
            : <h1>Coșul este gol</h1>
          : <div className={styles.content}>
            <div className={styles.inlineContainer}>
              {isMobile && <div className={styles.title}>
                <h2>Coșul meu</h2>
              </div>}
              <div className={styles.cartList}>
                <CartList cart={props.cart} setCart={props.setCart} />
              </div>
              <div className={styles.orderSummary}>
                <OrderSummary
                  subtotal={total}
                  taxes={0}        // Taxele comenzii
                  total={total}
                  setCurrentStep={props.setCurrentStep}
                />
              </div>
            </div>
          </div>
      }
      <NavLink to='/' className={styles.continueButton}><i className="fa-solid fa-chevron-left"></i>Continuațiu cumpăraturile</NavLink>
    </div>
  );
};

export default OrderReview;